import ActionBar from './ActionBar'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import List from './List'
import Detail from './Detail'
import ApplySetItemModal from './ApplySetItemModal'
import {pageRequest, cancelDeleteModifier, deleteModifier, confirmApplySetItem} from 'actions/library/modifier'
import {connect} from 'react-redux'
import LibraryDeleteModal from 'components/LibraryDeleteModal'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {isDirty} from 'redux-form'
import {browserHistory} from 'react-router'
import {askConfirmAction} from 'actions/confirm-action'
import {push} from 'react-router-redux'
import NoDataAndLoading from 'components/NoDataAndLoading'
import _ from 'lodash'
import * as mpLibraryModifier from 'mixpanel/library/modifier'

class Modifier extends React.Component {
  render () {
    const {showDeleteModifierModal, deletedModifier, openRightColumn, showLoadingSpinnerPage, modifiers} = this.props
    const modifierName = deletedModifier ? deletedModifier.name : ''
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={modifiers.length === 0}
              title='No Data To Display'
              description=''
              linkLabel='Create Modifiers'
              linkUrl='https://mokaposhelp.zendesk.com/hc/en-us/articles/115005340587-Create-Modifiers' />
            <List />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <Detail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ApplySetItemModal onSubmit={this._onSubmitApplySetItem} />
        <LibraryDeleteModal
          showDeleteModal={showDeleteModifierModal}
          onHide={this._onHideModal}
          title='Modifier'
          name={modifierName}
          onDelete={this._onDelete}
        />
        <ConfirmActionModal />
      </PageWrapper>
    )
  }

  componentDidMount () {
    const {dispatch, expired} = this.props
    if (!expired) {
      dispatch(pageRequest())
      browserHistory.listenBefore((location) => {
        // this is still hacky, don't copy paste this
        if (this.props.isDirtyModifier && !this.props.nextAction) {
          dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  _onHideModal = () => {
    this.props.dispatch(cancelDeleteModifier())
  }

  _onDelete = () => {
    const {dispatch, deletedModifier, modifiers} = this.props
    mpLibraryModifier.libraryModifierDelete({name: deletedModifier.name, options: deletedModifier.active_options})
    dispatch(deleteModifier(deletedModifier.id, modifiers))
  }

  _onSubmitApplySetItem = (values) => {
    const {dispatch, modifiers} = this.props
    let properties = {}
    _.forEach(modifiers, (modifier) => {
      if (modifier.id === values.id) {
        properties = {
          name: modifier.name,
          options: _.map(modifier.active_options, 'id'),
          itemNames: values.itemIds
        }
      }
    })
    mpLibraryModifier.libraryModifierApplyToItems(properties)
    dispatch(confirmApplySetItem({item_ids: values.itemIds}, values.id))
  }
}

function mapStateToProps (state) {
  const {showDeleteModifierModal, modifiers, deletedModifier, openRightColumn} = state.library.modifier
  const {showLoadingSpinnerPage} = state.loadingSpinner
  const {expired} = state.subscriptionExpired
  return {
    isDirtyModifier: isDirty('modifier')(state),
    nextAction: state.confirmAction.nextAction,
    showDeleteModifierModal,
    modifiers,
    deletedModifier,
    openRightColumn,
    showLoadingSpinnerPage,
    expired
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Modifier)



// WEBPACK FOOTER //
// ./app/pages/Library/Modifier/Modifier.js